import { Skeleton } from '~/chords/Skeleton';

export function TableCellSkeleton() {
  return (
    <div className="w-2xl">
      <Skeleton />
    </div>
  );
}

TableCellSkeleton.displayName = 'TableCellSkeleton';
